import React, { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { QuerySqlDocument } from '../../../generated/graphql';
import mutationVariables from '../../../utility/mutationVariables';
import { Container, Button, LinearProgress, Paper, TextField } from '@material-ui/core';
var defaultQuery = "#standardSQL\n  SELECT *\n  FROM YourDataSource.DataSet\n  LIMIT 1000;\n";
var QueryWriter = function (_a) {
    var datasourceId = _a.datasourceId, query = _a.query, setQuery = _a.setQuery, queryLoading = _a.queryLoading, setQueryLoading = _a.setQueryLoading, setRows = _a.setRows;
    var _b = useMutation(QuerySqlDocument), runQuery = _b[0], _c = _b[1], data = _c.data, loading = _c.loading;
    useEffect(function () {
        if (loading)
            setQueryLoading(true);
        if (data) {
            setRows(data.querySql.results);
            setQueryLoading(false);
        }
    }, [data, loading]);
    var handleChangeQuery = function (event) {
        setQuery(event.target.value);
    };
    var handleRunQuery = function () {
        if (!query) {
            return false;
        }
        runQuery(mutationVariables({ datasourceId: datasourceId, query: query }));
    };
    return (React.createElement(Container, null,
        React.createElement(Button, { variant: "contained", color: "primary", disabled: queryLoading, onClick: handleRunQuery, style: { float: 'right' } }, "Run Query"),
        React.createElement(Paper, { elevation: 0, style: { background: 'none' } },
            React.createElement(TextField, { multiline: true, fullWidth: true, variant: "outlined", rows: 10, rowsMax: 20, placeholder: defaultQuery, value: query, onChange: handleChangeQuery, style: { background: '#fff' } })),
        loading && React.createElement(LinearProgress, null)));
};
export default QueryWriter;
